// extracted by mini-css-extract-plugin
export default {"content":"Complete_content__y1nnS","icon":"Complete_icon__y0uMY","actions":"Complete_actions__UfcRl","spinner":"Complete_spinner__YN9P2"};